import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export default function ResetPasswordForm({ onSubmit, error, success, onPasswordChange, isPasswordValid }) {
  // hooks
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit({ password });
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    onPasswordChange(newPassword);
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        width: "100%",
      }}
    >
      <TextField
        label="Password"
        type={showPassword ? 'text' : 'password'}
        value={password}
        onChange={handlePasswordChange}
        aria-describedby={
            error ? "password-error" :
            success ? "password-success" :
            undefined
        }
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      {error && (
        <Typography
          id="password-error"
          variant="caption"
          color="error"
          sx={{ textAlign: "left", mt: -1, width: "100%" }}
        >
          {error}
        </Typography>
      )}

      {success && (
        <Typography
          id="password-success"
          variant="caption"
          color="success"
          sx={{ textAlign: "left", mt: -1, width: "100%" }}
        >
          {success}
        </Typography>
      )}

      <Button type="submit" variant="contained" color="primary" fullWidth disabled={!isPasswordValid}>
        Submit
      </Button>
    </Box>
  )
}